import Tooltip from 'style-guide/Tooltip';
import Title from 'style-guide/Typography/Title';
import Label from 'style-guide/Label';
import UserAvatar from 'style-guide/UserAvatar';
import Text from 'style-guide/Typography/Text';
import theme from 'style-guide/Theme';
import { Pencil, Trash } from '../../../style-guide/Icons';

const tooltipOverlayStyle = {
  maxWidth: '260px',
  backgroundColor: 'white',
  fontSize: '14px',
  color: 'black',
  boxShadow: '5px 10px 18px rgba(0, 0, 0, 0.25)',
  padding: '8px',
  borderRadius: '16px',
};

const Actions = ({ row, handlePencilClick, onDelete }) => (
  <div className='d-flex '>
    <Pencil className='icon pointer mr--16' onClick={() => handlePencilClick(row.id)} />
    <Trash className='icon pointer' onClick={() => onDelete(row.id)} />
  </div>
);

export const getSurveyManageColumns = ({ handlePencilClick, onDelete }) => [
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Linked LC',
    dataIndex: 'linkedLC',
    key: 'linkedLC',
    render: (value) => {
      const getLabelType = value.length > 0 ? 'processing' : 'default';
      const labelText = value.length > 0 ? `Linked to: ${value.length} LC` : 'Not linked';
      return (
        <Tooltip
          $disabled={!value.length}
          overlayInnerStyle={tooltipOverlayStyle}
          overlay={
            <div>
              <Title variant={5}>Linked LC's</Title>
              <ol type='1'>
                {value?.slice(0, 3).map((course) => (
                  <li key={course.id} className='mb--8'>
                    {course.name}
                  </li>
                ))}
                {value.length > 3 && <li className='mb--8'>and {value.length - 3} others...</li>}
              </ol>
            </div>
          }
          placement='top'
        >
          <Label type={getLabelType}>{labelText}</Label>
        </Tooltip>
      );
    },
  },
  {
    title: 'Created by',
    dataIndex: 'createdBy',
    key: 'createdBy',
    render: (value) => (
      <div className='d-flex align-items-center'>
        <UserAvatar userName={value.userName} picture={value.profileImage || null} className='mr--8' />
        <Text $variant={2} color={theme().colors.dark[80]} $ellipsis>
          {value.userName || 'Unknown User'}
        </Text>
      </div>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (value) => {
      const isPublished = value === 1;
      const getLabelType = isPublished ? 'success' : 'default';
      const getStatusText = isPublished ? 'Published' : 'Draft';
      return <Label type={getLabelType}>{getStatusText}</Label>;
    },
  },
  {
    title: 'Responses',
    dataIndex: 'responses',
    key: 'responses',
  },
  {
    title: 'Last updated',
    dataIndex: 'lastUpdated',
    key: 'lastUpdated',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    render: (_value, row) => <Actions row={row} handlePencilClick={handlePencilClick} onDelete={onDelete} />,
  },
];
